import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { UserService } from '../../../service/user/user.service';
import { User } from '../../../class/user';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoUser: User;
    public user: User;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public userService: UserService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelUser () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/users/user/user.component.ts